var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.357,
    height: 29.835,
    viewBox: "0 0 39.357 29.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09bc9d;}.b{fill:#078871;}.c{fill:#fff;}.d{fill:#e3f5ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.076,61.936H11.336a3.794,3.794,0,0,0-2.539.97l-.643,2.839V84.2a3.809,3.809,0,0,0,3.809,3.809H43.076l2.839-.681a3.8,3.8,0,0,0,.97-2.539V65.745A3.809,3.809,0,0,0,43.076,61.936Z",
    transform: "translate(-7.527 -61.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M115.6,434.818H91.474a.635.635,0,0,1,0-1.27H115.6a.635.635,0,0,1,0,1.27Z",
    transform: "translate(-83.856 -404.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M208.256,160.2l-9.857-4.929a1.3,1.3,0,0,0-.268-.1l-1.018,1.235v9.857l1.286.521,9.857-4.929.409-1.337A1.274,1.274,0,0,0,208.256,160.2Z",
    transform: "translate(-181.96 -148.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.809,98.972A2.539,2.539,0,0,1,1.27,96.433V74.55A3.808,3.808,0,0,0,0,77.389V96.433a3.809,3.809,0,0,0,3.809,3.809h31.74a3.808,3.808,0,0,0,2.839-1.27Z",
    transform: "translate(0 -73.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M194.26,163.968a1.9,1.9,0,0,1-2.756-1.7v-7.536a1.271,1.271,0,0,0-1.569,1.235v9.857a1.269,1.269,0,0,0,1.837,1.135l9.857-4.928a1.273,1.273,0,0,0,.409-1.951Z",
    transform: "translate(-175.334 -147.562)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.e08e9619cf97b93e5f927c068b7abdce.svg";
export { ForwardRef as ReactComponent };